import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";


// 👇 Combine the interfaces to represent a full video Topic item
export type IVideoTopic = any;

export const CourseDetailsVideoLessonsSlice = createSlice({
  name: "CourseDetailsVideoLessonsSlice",
  initialState: {} as IReduxState<IVideoTopic>,
  reducers: {
    CourseDetailsVideoLesson: (state, action) => {
      state.isLoading = true;
    },

    successCourseDetailsVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureCourseDetailsVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  CourseDetailsVideoLesson,
  successCourseDetailsVideoLessons,
  failureCourseDetailsVideoLessons,
} = CourseDetailsVideoLessonsSlice.actions;

export default CourseDetailsVideoLessonsSlice.reducer;
